import React from "react";
import { getDownloadURL, ref } from "firebase/storage";
import { storage, auth } from "../firebase";
import { Button } from "../design/button";
import { ArrowDownTrayIcon } from "@heroicons/react/16/solid";

interface DownloadFileButtonProps {
  path: string;
  label?: string;
}

const DownloadFileButton: React.FC<DownloadFileButtonProps> = ({ path, label = "Download" }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      // Force refresh token before download to ensure latest claims
      if (auth.currentUser) {
        await auth.currentUser.getIdToken(true);
      }

      const fileRef = ref(storage, path);
      const downloadUrl = await getDownloadURL(fileRef);
      window.open(downloadUrl, "_blank");
    } catch (error: any) {
      console.error("Download error:", error);
      // Show more specific error message
      const errorCode = error?.code || "unknown";
      const errorMessage = error?.message || "Unknown error";

      if (errorCode === "storage/unauthorized") {
        alert("You don't have permission to download this file. Please try logging out and back in.");
      } else if (errorCode === "storage/object-not-found") {
        alert("The file was not found. It may have been deleted.");
      } else {
        alert(`Failed to download file: ${errorMessage}`);
      }
    }
    setIsDownloading(false);
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={isDownloading}
      className="flex items-center gap-2"
    >
      <ArrowDownTrayIcon className={`w-4 h-4 ${isDownloading ? "animate-pulse" : ""}`} />
      {isDownloading ? "Loading..." : label}
    </Button>
  );
};

export default DownloadFileButton;
